import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "navigation/solutions-gateway-to-russia",
  "use": "navigation/solutions-gateway-to-russia-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"navigation/solutions-gateway-to-russia\">\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2 0a1 1 0 0 0-1 1v14a1 1 0 1 0 2 0v-5h3.05a2.5 2.5 0 0 0 2.45 2H14a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H9.95A2.5 2.5 0 0 0 7.5 0H2zm6 3v2a1 1 0 0 0 2 0V4h3v6H8.5a.5.5 0 0 1-.5-.5V9a1 1 0 0 0-1-1H3V2h4.5a.5.5 0 0 1 .5.5V3z\" fill=\"#5282FF\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol